export default (state, notifications) => ({ notifications });



// WEBPACK FOOTER //
// ./datastore/actions/set-notifications.js